export default __webpack_public_path__ + "static/media/aqi_2.c5cb0e9e.svg";